<div [@routeAnimations]="animationsService.getRouteAnimationData(null, false)" #container>
  <yrx-spacing type="L"></yrx-spacing>
  <router-outlet></router-outlet>
  <yrx-spacing type="L"></yrx-spacing>
</div>
